var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.49 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .op-cls-1 {\n        fill: #39fdc1;\n      }\n\n      .op-cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n\n      .op-cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ops_Button_Slider",
    "data-name": "Ops Button Slider"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "op-cls-1",
    cx: 52.74,
    cy: 52.74,
    r: 52.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "op-cls-2",
    d: "M450.59,471.54a33.81,33.81,0,0,1-59.57-1.3",
    transform: "translate(-368.4 -402.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "op-cls-2",
    d: "M392.42,437.08a33.81,33.81,0,0,1,58.23,1.34",
    transform: "translate(-368.4 -402.22)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "op-cls-2",
    points: "19.45 26.78 21.61 39.06 33.89 36.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "op-cls-2",
    points: "87.83 77.26 85.66 64.98 73.38 67.15"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "op-cls-3",
    cx: 52.74,
    cy: 52.74,
    r: 13.68
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperations);
export default __webpack_public_path__ + "static/media/Operations.b6aeb88375f8a14fd7b7769840c23dc0.svg";
export { ForwardRef as ReactComponent };